/* istanbul ignore file */
import { CreatePageLayout } from 'framework/ui/layout';
import { CreateForm } from 'framework/form';
import InstantFeedbackForm from 'domain/people/feedback/instantFeedback/createupdate/InstantFeedbackForm';
import useInstantFeedbackService from 'domain/people/feedback/instantFeedback/InstantFeedbackService';
import { OneStopModalDecorator, useOneStopRequestsUrl } from 'domain/shared/oneStop';
import { useNavigate } from 'react-router-dom';

const CreateInstantFeedback = () => {
  const { create, getValidationSchema } = useInstantFeedbackService();
  const { getListUrl } = useOneStopRequestsUrl();
  const navigate = useNavigate();

  const redirectToOneStopRequests = () => navigate(getListUrl());

  return (
    <OneStopModalDecorator
      isOneStop={false}
      messageContext="feedbackForm"
      handleMessageModalClose={redirectToOneStopRequests}
    >
      <CreateForm
        submitFormFunc={create}
        getValidationSchemaFunc={getValidationSchema}
        initialData={{
          isSharedWithEmployee: false,
        }}
      >
        <CreatePageLayout title="Feedback about colleague" isCancelButtonVisible={false}>
          <InstantFeedbackForm isPageForm />
        </CreatePageLayout>
      </CreateForm>
    </OneStopModalDecorator>
  );
};

export default CreateInstantFeedback;
